export { default as InputSearch } from './input-search/InputSearch'
export { default as SearchResult } from './search-result/SearchResult'
